import styles from '../Confirmation.module.scss'
import { Heading } from '@boltenergy-be/design-system'
import Link from 'components/link/Link'
import { routes } from 'utils/routes'
import { CldImage } from 'next-cloudinary'
import { ConfirmationProps } from '../types'
import ConfirmationWrapper from '../components/ConfirmationWrapper'
import { useTranslation } from 'next-i18next/pages'
import { useRouter } from 'next/router'

const ExtraAddressView = ({ producer }: ConfirmationProps) => {
  // i18n
  const { t } = useTranslation('registration')

  // Next router
  const { locale } = useRouter()

  return (
    <ConfirmationWrapper>
      <section className={styles['confirmation-card']}>
        <div className={styles.text}>
          <Heading as="h2" variant="h3" serif className="mb-400">
            {t(`confirmation.extraAddress.title.confirmed`, { producer: producer?.name?.[locale] })}
          </Heading>

          <p className="mb-500">{t('confirmation.extraAddress.description')}</p>

          <Link representation="button" href={routes(locale).home}>
            {t('confirmation.extraAddress.backToHome')}
          </Link>
        </div>

        {producer?.images?.profile?.url && (
          <div className={styles.image}>
            <CldImage fill src={producer.images.profile?.url} alt={producer.name[locale]} />
          </div>
        )}
      </section>
    </ConfirmationWrapper>
  )
}

export default ExtraAddressView
